import { AbstractApi } from '../abstract-api';
import { BannerApi, GraphQLApi, InfoBannerApi } from './endpoints';

export class ContentApi extends AbstractApi {
  public graphQl = new GraphQLApi(this.params);

  public banner = new BannerApi(this.params);

  public infoBanner = new InfoBannerApi(this.params);
}